import { Component } from "grapesjs";
import { CreatedMenu, createSlug, SubMenu } from "../features/addMenu";
import { useEffect, useState } from "react";
import { getMenuItem, getMenuItems } from "../utils/requests";
import PopupWrapper from "../components/PopupWrapper";
import { Loading } from "mdi-material-ui";
import { AppDispatch } from "../app/store";
import { setGlobalSortPopupElement } from "../features/popupSlice";
import { getPageRoute } from "../utils/constants";

export const menuComponentType = "nav-menu-section";
export const menuIdData = "data-menu-id";
export const menuSlugData = "data-menu-slug";

export const menuItemComponent = (
    item: SubMenu,
    key: string = "uid"
): string => {
    return `
        <div class="relative group/${key}">
            <div class="flex items-center gap-2">
                <a href="${getPageRoute(
                    item.type || "custom",
                    item.url
                )}" class="flex-1 block px-2 py-1 text-sm text-gray-900 rounded-sm hover:bg-gray-100">${
        item.name
    }</a>
                ${
                    item.submenu?.length > 0
                        ? `
                    <svg class="w-4 h-4 text-gray-500 group-hover/${key}:text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    `
                        : ""
                }
            </div>

            ${
                item.submenu?.length > 0
                    ? `
                <div class="absolute z-10 left-full top-0 ml-2 min-w-[180px] bg-white rounded-sm shadow-sm ring-1 ring-gray-900/5 
						opacity-0 scale-0 origin-top-left transition-all duration-200 group-hover/${key}:opacity-100 group-hover/${key}:scale-100">
                    <div class="p-2 py-1 space-y-1">
                        ${item.submenu
                            ?.map((subItem, j) =>
                                menuItemComponent(
                                    subItem,
                                    key +
                                        "-" +
                                        j +
                                        "-" +
                                        createSlug(subItem.name)
                                )
                            )
                            .join(" ")}
                    </div>
                </div>
                `
                    : ""
            }
        </div>
    `;
};

export const menuLayoutComponent = (menuItems: SubMenu[]) => {
    return `
        <div id="${menuComponentType}" class="flex items-center gap-2 px-4 py-2">
            ${menuItems
                ?.map((item, index) => {
                    const key = `${index}-${createSlug(item.name)}`;

                    return `
                            <div class="relative group/${key}">
                                <a href="${getPageRoute(
                                    item.type || "custom",
                                    item.url
                                )}" class="block px-4 py-2 text-sm text-gray-900 rounded-sm hover:bg-gray-100">${
                        item.name
                    }</a>
                                
                                ${
                                    item.submenu?.length > 0
                                        ? `
                                    <div class="absolute z-10 left-0 mt-0 min-w-[200px] bg-white rounded-sm shadow-sm ring-1 ring-gray-900/5 opacity-0 scale-0 origin-top-left transition-all duration-200 group-hover/${key}:opacity-100 group-hover/${key}:scale-100">
                                    <div class="p-2 py-1 space-y-1">
                                        ${item.submenu
                                            ?.map((subItem, j) =>
                                                menuItemComponent(
                                                    subItem,
                                                    key +
                                                        "-" +
                                                        j +
                                                        "-" +
                                                        createSlug(subItem.name)
                                                )
                                            )
                                            .join(" ")}
                                    </div>
                                </div>
                                `
                                        : ""
                                }
                            </div>

                        `;
                })
                .join(" ")}
        </div>
    </div>
    `;
};

export const menuComponentConfigs = (component: any) => {
    component.set("traits", [
        {
            type: "select",
            name: "Menu Type",
            options: [
                { value: "primary", label: "Primary" },
                { value: "secondary", label: "Secondary" },
                { value: "tertiary", label: "Tertiary" },
            ],
        },
    ]);
};

export const menuSelectHandler = (dispatch: AppDispatch, model: any) => {
    dispatch(
        setGlobalSortPopupElement(
            <MenuSelectPopup
                onSelect={(menu: CreatedMenu) => {
                    const content = menuLayoutComponent(menu.menu);

                    model.components(content);
                    model.setAttributes({
                        [menuIdData]: menu._id,
                        [menuSlugData]: createSlug(menu.name),
                    });

                    dispatch(setGlobalSortPopupElement(null));
                }}
                onClose={() => {
                    dispatch(setGlobalSortPopupElement(null));
                }}
            />
        )
    );
};

export const MenuSelectPopup = ({
    onSelect,
    onClose,
}: {
    onSelect: (res: CreatedMenu) => void;
    onClose: () => void;
}) => {
    const [menus, setMenus] = useState<CreatedMenu[]>([]);

    useEffect(() => {
        const fetchMenus = async () => {
            const result = await getMenuItems();

            setMenus(result);
        };
        fetchMenus();
    }, []);

    return (
        <PopupWrapper onClose={onClose}>
            <div className="p-4 w-[80vw] max-w-[400px]">
                <div>
                    <p className="text-base font-semibold">
                        Select a menu to set the menu structure
                    </p>
                </div>
                <div className="py-2 flex flex-col gap-3 overflow-y-auto max-h-[400px]">
                    {menus.map((menu, index) => (
                        <div
                            key={index}
                            onClick={() => onSelect(menu)}
                            className="p-2 cursor-pointer bg-gray-50 rounded-sm shadow-md hover:bg-gray-100"
                        >
                            <p>{menu.name}</p>
                        </div>
                    ))}
                </div>

                {menus.length === 0 && (
                    <div className="py-2 flex items-center justify-center">
                        {/* loading */}
                        <Loading className="w-6 h-6 animate-spin" />
                    </div>
                )}
            </div>
        </PopupWrapper>
    );
};

export const findMenuId = (component: any): string | undefined => {
    if (component?.attributes?.["data-menu-id"]) {
        return component?.attributes?.["data-menu-id"];
    }

    return component?.attributes?.attributes?.["data-menu-id"];
};

export default () => <></>;
